import type { ComponentType } from 'react'

import type { SpotlightTourDebugId } from './spotlightTourDebugConfig'
import { SpotlightTourDebugSection } from './SpotlightTourDebugSection'

/** Stable panel component for a tour id — use as `Component` in `registerDebugPanelSection`. */
export function createSpotlightTourDebugSection(tourId: SpotlightTourDebugId): ComponentType {
  const Section = () => <SpotlightTourDebugSection tourId={tourId} />
  Section.displayName = `SpotlightTourDebugSection(${tourId})`
  return Section
}
